import { useEffect, useState } from "react";
import {
    Box, Collapse, Divider, Drawer, IconButton, List,
    ListItem, ListItemIcon, ListItemText, ListSubheader,
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import TableViewIcon from '@mui/icons-material/TableView';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublicIcon from "@mui/icons-material/Public";
import BallotIcon from '@mui/icons-material/Ballot';
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import ArticleIcon from "@mui/icons-material/Article";
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DatasetIcon from '@mui/icons-material/Dataset';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PaidIcon from '@mui/icons-material/Paid';
import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight';
import CalculateIcon from '@mui/icons-material/Calculate';
import DownloadIcon from '@mui/icons-material/Download';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { makeStyles } from "@material-ui/core/styles";
import CustomBreadcrumbs from "./breadcrumbs/CustomBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { MAX_MOBILE_WIDTH, profilToAccessToAllFonctionnality } from "../../constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import { Reducers } from "../../redux/reducers";
import UserInformation from "../../types/UserInformation";
import Cookies from "universal-cookie";
import { deleteArticleInformationParam } from "../../redux/actions/articleParam";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EuroIcon from '@mui/icons-material/Euro';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        maxWidth: 460
    },
    menuItemHover: {
        "&:hover": {
            backgroundColor: "#080d24 !important",
            cursor: 'pointer'
        }
    },
    nested: {
        paddingLeft: theme.spacing(4),
        color: '#fff',
        "&:hover": {
            backgroundColor: "#080d24 !important",
            textDecoration: 'none',
            cursor: 'pointer'
        },
        "&:active": {
            backgroundColor: "#080d24 !important"
        }
    }
}));
interface SubMenu {
    subTitle: string;
    icon: JSX.Element;
    path: string;
    code: string;
}

const subMenusForParametres: SubMenu[] = [
    {
        subTitle: 'Pays',
        icon: <PublicIcon />,
        path: '/pays',
        code: 'PAYS'
    },
    {
        subTitle: 'Business Units',
        icon: <BallotIcon />,
        path: '/business-units',
        code: 'BU'
    },
    {
        subTitle: 'Clients',
        icon: <AssignmentIndIcon />,
        path: '/clients',
        code: 'CLT'
    },
    {
        subTitle: 'Opérations',
        icon: <DynamicFormIcon />,
        path: '/operations',
        code: 'OPERA'
    },
    {
        subTitle: 'Articles',
        icon: <ArticleIcon />,
        path: '/article',
        code: 'ARTL'
    },
    {
        subTitle: 'Tarifs',
        icon: <PriceCheckIcon />,
        path: '/tarifs',
        code: 'TRF'
    },
    {
        subTitle: 'Coûts',
        icon: <LegendToggleIcon />,
        path: '/couts',
        code: 'COUT'
    },
    {
        subTitle: 'Manager par opérations',
        icon: <ReduceCapacityIcon />,
        path: '/Managers-operations',
        code: 'MNGR_OPERA'
    },
    {
        subTitle: 'Taux de change',
        icon: <TrendingUpIcon />,
        path: '/taux',
        code: 'TAUX'
    },
    {
        subTitle: 'Dates de verrouillage',
        icon: <InsertInvitationIcon />,
        path: '/date-verouillage',
        code: 'DATE_VERR'
    },
    {
        subTitle: "Date de verrouillage et clôture Budget",
        icon: <CalendarMonthIcon />,
        path: '/date-verouillage-cloture-budget',
        code: 'DATE_VERR_CLO_BUDGET',
    },
    {
        subTitle: "Date de verrouillage et clôture Reforecast",
        icon: <DateRangeIcon />,
        path: '/date-verouillage-cloture-reforecast',
        code: 'DATE_VERR_CLO_REFOR',
    },
    {
        subTitle: 'Secteurs d\'activités',
        icon: <AccountBalanceWalletIcon />,
        path: '/secteur-act',
        code: 'SECT_ACT'
    },
    {
        subTitle: 'Utilisateurs',
        icon: <ManageAccountsIcon />,
        path: '/user',
        code: 'USER'
    }
];

const subMenusForProduction: SubMenu[] = [
    {
        subTitle: 'Saisie Manager',
        icon: <AppRegistrationIcon />,
        path: '/saisie-agent',
        code: 'HOURS_AGENT'
    }
];

const subMenusForBudget: SubMenu[] = [
    {
        subTitle: 'Budget',
        icon: <ListAltIcon />,
        path: '/budget-client',
        code: 'BUDGET'
    },
    {
        subTitle: 'Extraction Budget',
        icon: <DatasetIcon />,
        path: '/extraction-budget',
        code: 'EXT_BUDGET'
    },
    {
        subTitle: 'Import Budget',
        icon: <DownloadIcon />,
        path: '/import-budget',
        code: 'IMP_BUDGET'
    }
];

const subMenusForReforcast: SubMenu[] = [
    {
        subTitle: 'Reforecast',
        icon: <ListAltIcon />,
        path: '/reforecast',
        code: 'REFOR'
    },
    {
        subTitle: 'Extraction Reforecast',
        icon: <DownloadForOfflineIcon />,
        path: '/extraction-reforecast',
        code: 'EXT_REFOR'
    },
    {
        subTitle: 'Extraction Consolidation Reforecast',
        icon: <AlignVerticalCenterIcon />,
        path: '/extraction-consolidation-reforcast',
        code: 'EXT_CONSO_REFOR'
    },
    {
        subTitle: 'Import Reforecast',
        icon: <DownloadIcon />,
        path: '/import-reforcast',
        code: 'IMP_REFOR'
    }
];

const subMenusForExtraction: SubMenu[] = [
    {
        subTitle: 'Saisie',
        icon: <AlignVerticalCenterIcon />,
        path: '/extraction-saisie',
        code: 'EXT_SAISIE'
    },
    {
        subTitle: 'Rentabilité',
        icon: <AlignHorizontalRightIcon />,
        path: '/rentabilite',
        code: 'EXTRACT_FACT'
    }
];

const subMenusForFacturation: SubMenu[] = [
    {
        subTitle: 'Générer Facture',
        icon: <CalculateIcon />,
        path: '/generate-facture',
        code: 'FACTURE'
    },
    {
        subTitle: 'Facture Proforma',
        icon: <ReceiptLongIcon />,
        path: '/facturepro',
        code: 'FACTUREPRO'
    }, {
        subTitle: 'Tableau de bord',
        icon: <DashboardIcon />,
        path: '/tableau-de-bord',
        code: 'DASHBOARD_FACT'
    }
];

const subMenusForCommission: SubMenu[] = [
    {
        subTitle: 'Commerciaux/DRC',
        icon: <SupportAgentIcon />,
        path: '/commission',
        code: 'COM_COM'
    },
    {
        subTitle: 'Extraction Commission Commerciaux',
        icon: <DownloadIcon />,
        path: '/extraction-commission',
        code: 'EXT_COMM'
    }
];

const NavbarChild = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const cookies = new Cookies();
    const verticalMenu: boolean = cookies.get("menu");

    const user = useSelector<Reducers>(
        (state) => state.logger
    ) as UserInformation;

    const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

    const [states, setStates] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [open, setOpen] = useState<boolean>(false);
    const [open1, setOpen1] = useState<boolean>(false);
    const [open2, setOpen2] = useState<boolean>(false);
    const [open3, setOpen3] = useState<boolean>(false);
    const [open4, setOpen4] = useState<boolean>(false);
    const [open5, setOpen5] = useState<boolean>(false);
    const [open6, setOpen6] = useState<boolean>(false);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const toggleDrawer = (anchor: any, open: boolean, pathname?: string) => (event: any) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setStates({ ...states, [anchor]: open });

        if (pathname) {
            // Suppremer l Article Info Dans Redux
            dispatch(deleteArticleInformationParam());
            navigate(pathname);
            setOpen(false);
            setOpen1(false);
            setOpen2(false);
            setOpen3(false);
            setOpen4(false);
            setOpen5(false);
        }
    };

    const displayMenu = (menuItem: SubMenu[]) => {
        if (user?.profils?.libelle && profilToAccessToAllFonctionnality?.includes(user?.profils?.libelle)) {
            return true;
        } else {
            return menuItem.find(elem => user?.features?.includes(elem?.code));
        }
    };

    const handleClick = () => {
        setOpen(!open);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
        setOpen6(false);
    };

    const handleClick1 = () => {
        setOpen(false);
        setOpen1(!open1);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
        setOpen6(false);
    };

    const handleClick2 = () => {
        setOpen(false);
        setOpen1(false);
        setOpen2(!open2);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
        setOpen6(false);
    };

    const handleClick3 = () => {
        setOpen(false);
        setOpen1(false);
        setOpen2(false);
        setOpen3(!open3);
        setOpen4(false);
        setOpen5(false);
        setOpen6(false);
    };

    const handleClick4 = () => {
        setOpen(false);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen4(!open4);
        setOpen5(false);
        setOpen6(false);
    };

    const handleClick5 = () => {
        setOpen(false);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(!open5);
        setOpen6(false);
    };

    const handleClick6 = () => {
        setOpen(false);
        setOpen1(false);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
        setOpen6(!open6);
    };

    const showSubMenu = (item: SubMenu) => {
        /**
         * Si le profil est ADMIN
         * ou si le menu est inclus dans la liste des fonctionnalité correspond au profil,
         * alors, on affiche le sous-menu
         */
        if ((user?.profils?.libelle && profilToAccessToAllFonctionnality?.includes(user?.profils?.libelle)) ||
            (user?.updated_password && user?.features?.includes(item.code))) {
            return <ListItem className={classes.nested} onClick={toggleDrawer('left', false, item.path)}>
                <ListItemIcon sx={{ color: '#fff' }}>
                    {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.subTitle} />
            </ListItem>;
        }
    }

    const list = (anchor: any) => (
        <Box
            // sx={{ width: 250 }}
            sx={{ width: 282 }}
            role="presentation"
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"

                subheader={
                    <ListSubheader component="div" id="nested-list-subheader" sx={{
                        backgroundColor: '#080d24',
                        paddingTop: 2.5,
                        // paddingLeft: 0,
                        height: 115
                    }}>
                        <img
                            src="images/logo_outsourcia.png"
                            width="90%"
                            alt="Logo Outsourcia"
                            style={{ marginLeft: -4 }}
                        />
                    </ListSubheader>
                }
                className={classes.root}
            >
                {displayMenu(subMenusForParametres) && (
                    <>
                        <ListItem onClick={handleClick} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <SettingsIcon />
                            </ListItemIcon>
                            <ListItemText primary="Paramètrages" />
                            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForParametres?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForProduction) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick1} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <QrCodeIcon />
                            </ListItemIcon>
                            <ListItemText primary="Production" />
                            {open1 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open1} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForProduction?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForBudget) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick2} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <PaidIcon />
                            </ListItemIcon>
                            <ListItemText primary="Budget" />
                            {open2 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open2} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForBudget?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForReforcast) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick6} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <CurrencyExchangeIcon />
                            </ListItemIcon>
                            <ListItemText primary="Reforecast" />
                            {open2 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open6} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForReforcast?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForExtraction) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick3} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <DataThresholdingIcon />
                            </ListItemIcon>
                            <ListItemText primary="Extraction" />
                            {open3 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open3} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForExtraction?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForFacturation) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick4} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <TableViewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Facturation" />
                            {open4 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open4} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForFacturation?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}

                {displayMenu(subMenusForCommission) && (
                    <>
                        <Divider sx={{ color: '#080d24' }} />
                        <ListItem onClick={handleClick5} className={classes.menuItemHover}>
                            <ListItemIcon sx={{ color: '#fff' }}>
                                <EuroIcon />
                            </ListItemIcon>
                            <ListItemText primary="Commission" />
                            {open5 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse in={open5} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding dense>
                                {subMenusForCommission?.map(item => showSubMenu(item))}
                            </List>
                        </Collapse>
                    </>
                )}
            </List>
        </Box>
    );

    return (
        <div className='navbar-child'>
            <IconButton sx={{ p: 0 }} disabled={(!verticalMenu && (screenWidth > MAX_MOBILE_WIDTH)) && true}>
                <MenuIcon
                    onClick={
                        toggleDrawer("left", true)
                    }
                    sx={{
                        color: '#fff',
                        visibility: (!verticalMenu && (screenWidth > MAX_MOBILE_WIDTH)) ? 'hidden' : 'visible'
                    }}
                />
            </IconButton>

            <CustomBreadcrumbs screenWidth={screenWidth} />

            <Drawer
                anchor={"left"}
                open={states["left"]}
                onClose={toggleDrawer("left", false)}
                PaperProps={{
                    sx: {
                        backgroundColor: '#FC8404',
                        color: '#fff'
                    }
                }}
            >
                {list("left")}
            </Drawer>
        </div>
    );
};

export default NavbarChild;
